var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 9V9.8C12.9996 10.9201 12.9996 11.4802 12.7816 11.908C12.5899 12.2843 12.2839 12.5903 11.9076 12.782C11.4798 13 10.9198 13 9.79969 13H4.19989C3.07982 13 2.51979 13 2.09198 12.782C1.71567 12.5903 1.40972 12.2843 1.21798 11.908C1 11.4802 1 10.9201 1 9.8V9M10.333 4.33333L6.99979 1M6.99979 1L3.66657 4.33333M6.99979 1V9",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.1168cea2c6a35b839bf43493c9e9f0ba.svg";
export { ForwardRef as ReactComponent };